import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import LearnerProgrammesList from '../../Components/CoachProgrammesList';
import Toolbar from '../../Components/Toolbar';
import AddCodePopup from '../../Components/Popups/AddCodePopup';
import ThinkToolPopup from '../../Components/Popups/ThinkToolPopup';
import SaveEditPopup from '../../Components/Popups/SaveEditPopup';
import InviteDeclineReasonPopup from '../../Components/Popups/InviteDeclineReasonPopup';

import Notification from '../../Components/Popups/Notification';

import { commonStyles } from '../../styles/styles';
import BreadCrumbArea from '../../Components/BreadCrumbArea';
import { MDBContainer, MDBRow, MDBCol, MDBIcon, MDBBtn, MDBAnimation} from "mdbreact";


import ChangeProfilePopup from '../../Components/Popups/ChangeProfilePopup';
import CoachProgrammesList from '../../Components/CoachProgrammesList';
import CoachCard from '../../Components/Cards/CoachCard';
import CoachProjectsList from '../../Components/CoachProjectsList';

const CoachView = ({ classes, view, showProfile }) => (
  
  
    <div className={classes.mainBackground}>
      <MDBRow className="m-0">
          <MDBCol lg="3" md="4" sm="5"><CoachCard/></MDBCol>
          <MDBCol lg="9" md="8" sm="7"><CoachProjectsList/></MDBCol>
      </MDBRow>
    
    
      {view.thinkToolPopup && <ThinkToolPopup />}
      {view.saveEditPopup && <SaveEditPopup />}
      {view.declineInviteReasonPopup && <InviteDeclineReasonPopup />}
      {view.notification && (
        <Notification type={view.notificationType} text={view.notificationMessage} timeOut={5000} />
      )}
       {/* {showProfile && (
        <ChangeProfilePopup/>
      )} */}
    </div>
   
    

);

const styles = () => ({
  ...commonStyles,
  userListColumn: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 0,
    maxWidth: 267,
    zIndex:1000,
  },
  toolsColumn: {
    display: 'flex',
    flexGrow: 1,
    flexShrink: 0,
    position: 'relative',
    flexDirection: 'column',
    left:-10,
    maxWidth: 230,
    zIndex:900,
  },
  dashboardColumn: {
    display: 'flex',
    flex: 5,
    paddingBottom:5
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    height:'100%',
    paddingBottom:10,
    alignItems: 'stretch',
    overflow: 'auto',
    backgroundColor: '#e8e8e8'
  }
});

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  view: state.viewReducer,
  savedVersions: state.savedVersionsReducer,
  showProfile: state.userProgramsFullReducer.showProfile,
});


export default compose(
 
  withStyles(styles)
  )(CoachView);

CoachView.propTypes = {
  classes: PropTypes.instanceOf(Object),
  view: PropTypes.instanceOf(Object),
};



// WEBPACK FOOTER //
// ./src/Screens/Components/CoachView.jsx